import {
    madnes_add_group,
    madnes_add_img,
    madnes_add_sprite, madnes_add_to_group, madnes_destroy_group, madnes_remove_sprite,
    madnes_set_alpha, madnes_set_img_center, madnes_set_pos, madnes_set_pos_x
} from "../framework/src/engine/madnes/madnes_object";
import {
    fps,
    picture_convert,
    reels_pos,
    onfig,
    wi,
    ico_he,
    behavior_config,
    server_config,
    wallet,
    reels_lenghts, he, wi_scale, ico_wi, he_scale,
    systemConfig
} from "../framework/src/engine/madnes/madnes_variables";
import {
    bet,
    madnes_check_focus, madnes_get_atomic_bet,
    madnes_get_json, madnes_money_to_coin,
    madnes_set_blend_mode, madnes_set_input_down, madnes_set_input_up,
    madnes_set_win_factors
} from "../framework/src/engine/madnes/madnes";
import {
    madnes_add_graphics,
    madnes_add_mask,
    madnes_graphics_begin_fill
} from "../framework/src/engine/madnes/madnes_draw";
import {
    madnes_audio_allow_multiple,
} from "../framework/src/engine/madnes/madnes_audio";
import {
    madnes_add_bitmap_text,
    madnes_add_text,
    madnes_set_bitmap_float, madnes_set_text
} from "../framework/src/engine/madnes/madnes_text";
import {main_phaser} from "../framework/src/engine/madnes/MadnesApp";
import {cylinder_pos, icons} from "./ib27_config";
import {madnes_anim_add, madnes_anim_add_oncomplete, madnes_anim_play} from "../framework/src/engine/madnes/madnes_anims";
import {stopposin, stopposin_old} from "./ib27_core";
import {mystery_btn_end, mystery_btn_dn, mystery_btn_up} from "./ib27_anims";
import { CONFIG_PARAMS, MODES } from "../framework/src/system/SystemConfig";

// Vytvoreni potrebnych onjektu z nactenych textur.
export function ib27_print_desk()
{
    if(typeof behavior_config.reel.spin.motionBlur == "undefined")
    {
        behavior_config.reel.spin.motionBlur = 1;
    }

    if(typeof behavior_config.reel.spin.timeToReachFullSpeed == "undefined")
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
        if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
        {
            behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
        }
    }

    if(typeof behavior_config.reel.spin.timeToReachNullSpeed == "undefined")
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
        if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
        {
            behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
        }
    }

    //behavior_config.reel.spin.timeToReachNullSpeed = 0;

    if(typeof behavior_config.reel.acceleration.moveTime != "undefined")
    {
        behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.moveTime;
    }

    if(typeof behavior_config.reel.brake.moveTime != "undefined")
    {
        behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.brake.moveTime;
    }

    if(behavior_config.reel.spin.timeToReachFullSpeed == 0)
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.01;
    }

    if(behavior_config.reel.spin.timeToReachNullSpeed == 0)
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.01;
    }

    if(behavior_config.reel.spin.timeToReachFullSpeed > 0.5)
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
    }

    if(behavior_config.reel.spin.timeToReachNullSpeed > 0.5)
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
    }

    madnes_set_win_factors(
        behavior_config.reel.minBigWinFactor,
        behavior_config.reel.minMegaWinFactor,
        behavior_config.reel.minSuperMegaWinFactor
    );

    // if(
    // 	typeof server_config.logic != "undefined" &&
    // 	typeof server_config.logic.bet_set != "undefined"
    // )
    // {
    // 	//bets = server_config.logic.bet_set;
    // 	/*var bet0 = [];
    // 	for(var b in server_config.logic.bet_set)
    // 	{
    // 		if(
    // 			server_config.logic.bet_set[b] >= 10 &&
    // 			server_config.logic.bet_set[b] <= 100
    // 		)
    // 		{
    // 			bet0[bet0.length] = server_config.logic.bet_set[b];
    // 		}
    // 	}
    // 	bets = bet_set = bet0;*/
    //
    // 	bets = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
    // }

    madnes_add_img("background", "background", 0, 0);

    ////////////////////////////////////////////////////////////////////////////////

    var style = {
        font: "26px Arial",
        fontWeight: "bold",
        fill: "#dd00cc",
        align: "left",
        boundsAlignH: "left",
        boundsAlignV: "top",
        wordWrap: false,
        wordWrapWidth: 300
    };

    for(var i = 0; i < cylinder_pos.length; i++)
    {
        var tmp_len = server_config.logic.reels[i].length;
        for(var j = 0; j < tmp_len; j++)
        {
            //server_config.logic.reels[i][j + tmp_len] = server_config.logic.reels[i][j];
        }
    }

    // Nastaveni / vytvoreni pasu pro valce podle navratu ze serveru
    for(var i = 0; i < 3; i++)
    {
        for(var j in server_config.logic.reels[i])
        {
            madnes_add_sprite("reels_bufer_" + i + "_" + j, picture_convert[server_config.logic.reels[i][j]] + "_blur", cylinder_pos[i], -9999);
            madnes_anim_add("reels_bufer_" + i + "_" + j, "blur", [0]);
            madnes_anim_add("reels_bufer_" + i + "_" + j, "stop", [1]);

            madnes_anim_play("reels_bufer_" + i + "_" + j, "stop");

            reels_lenghts[i] = j * 1 + 1;
            stopposin[i] = reels_lenghts[i];
            stopposin_old[i] = reels_lenghts[i];
        }

        // S0-S2 = priprava vyherni pozice na kazdem valci
        madnes_add_sprite("reels_bufer_" + i + "_S0", picture_convert[server_config.logic.failResult[i][2]] + "_blur", cylinder_pos[i], 10);
        madnes_add_sprite("reels_bufer_" + i + "_S1", picture_convert[server_config.logic.failResult[i][1]] + "_blur", cylinder_pos[i], 10);
        madnes_add_sprite("reels_bufer_" + i + "_S2", picture_convert[server_config.logic.failResult[i][0]] + "_blur", cylinder_pos[i], 10);

        madnes_anim_add("reels_bufer_" + i + "_S0", "blur", [0]);
        madnes_anim_add("reels_bufer_" + i + "_S0", "stop", [1]);
        madnes_anim_play("reels_bufer_" + i + "_S0", "stop");

        madnes_anim_add("reels_bufer_" + i + "_S1", "blur", [0]);
        madnes_anim_add("reels_bufer_" + i + "_S1", "stop", [1]);
        madnes_anim_play("reels_bufer_" + i + "_S1", "stop");

        madnes_anim_add("reels_bufer_" + i + "_S2", "blur", [0]);
        madnes_anim_add("reels_bufer_" + i + "_S2", "stop", [1]);
        madnes_anim_play("reels_bufer_" + i + "_S2", "stop");

        madnes_add_sprite("reels_bufer_" + i + "_TMP2", picture_convert[server_config.logic.failResult[i][0]] + "_blur", cylinder_pos[i], -9999);
        madnes_add_sprite("reels_bufer_" + i + "_TMP1", picture_convert[server_config.logic.failResult[i][1]] + "_blur", cylinder_pos[i], -9999);
        madnes_add_sprite("reels_bufer_" + i + "_TMP0", picture_convert[server_config.logic.failResult[i][2]] + "_blur", cylinder_pos[i], -9999);

        madnes_anim_play("reels_bufer_" + i + "_S0", "stop");
        madnes_anim_play("reels_bufer_" + i + "_S1", "stop");
        madnes_anim_play("reels_bufer_" + i + "_S2", "stop");

        reels_pos[i] = 0;
    }

    madnes_add_img("bckground2", "reels_cover", 0, 0);


    madnes_add_img("middle_2", "middle_x2", -9999, -9999, 1, 0.5, 0.5);
    // madnes_add_img("middle_2", "middle_x3", -9999, -9999, 1, 0.5, 0.5);
    madnes_add_img("middle_4", "middle_x4", -9999, -9999, 1, 0.5, 0.5);
    // madnes_add_img("middle_4", "middle_x5", -9999, -9999, 1, 0.5, 0.5);
    madnes_add_img("middle_6", "middle_x6", -9999, -9999, 1, 0.5, 0.5);
    madnes_add_img("middle_8", "middle_x8", -9999, -9999, 1, 0.5, 0.5);
    madnes_add_img("middle_16", "middle_x16", -9999, -9999, 1, 0.5, 0.5);
    madnes_add_img("middle_32", "middle_x32", -9999, -9999, 1, 0.5, 0.5);

    //madnes_set_pos("middle_1", wi / 2, he / 2);

    //"sparkle" : "img/reels/sparkle_{q}.png",


    madnes_add_img("mystery_fadeout", "mystery_fadeout", -9999, -9999);
    madnes_add_img("mystery_selection", "mystery_selection", -9999, -9999);

    madnes_add_bitmap_text("mystery_result_1_text", "font_mystery_wintable", -9999, -9999, "0", 80);
    madnes_add_bitmap_text("mystery_result_2_text", "font_mystery_wintable", -9999, -9999, "0", 80);
    madnes_add_bitmap_text("mystery_result_3_text", "font_mystery_wintable", -9999, -9999, "0", 80);

    madnes_add_sprite("mystery_result_1", "mystery_red", -9999, -9999);
    madnes_add_sprite("mystery_result_2", "mystery_gold", -9999, -9999);
    madnes_add_sprite("mystery_result_3", "mystery_green", -9999, -9999);

    madnes_add_sprite("mystery_symbol_1", "symbol_BAR", -9999, -9999);
    madnes_add_sprite("mystery_symbol_2", "symbol_BAR", -9999, -9999);
    madnes_add_sprite("mystery_symbol_3", "symbol_BAR", -9999, -9999);

    for(var anim in icons["symbol_BAR"])
    {
        madnes_anim_add("mystery_symbol_1", anim, icons["symbol_BAR"][anim]);
        madnes_anim_add("mystery_symbol_2", anim, icons["symbol_BAR"][anim]);
        madnes_anim_add("mystery_symbol_3", anim, icons["symbol_BAR"][anim]);

        madnes_anim_add_oncomplete("mystery_symbol_1", mystery_btn_end.bind(this, 1));
        madnes_anim_add_oncomplete("mystery_symbol_2", mystery_btn_end.bind(this, 2));
        madnes_anim_add_oncomplete("mystery_symbol_3", mystery_btn_end.bind(this, 3));

    }

    madnes_add_sprite("mystery_symbol_boom_1", "symbol_BAR_boom", -9999, -9999);
    madnes_add_sprite("mystery_symbol_boom_2", "symbol_BAR_boom", -9999, -9999);
    madnes_add_sprite("mystery_symbol_boom_3", "symbol_BAR_boom", -9999, -9999);

    for(var anim in icons["symbol_BAR_boom"])
    {
        madnes_anim_add("mystery_symbol_boom_1", anim, icons["symbol_BAR_boom"][anim]);
        madnes_anim_add("mystery_symbol_boom_2", anim, icons["symbol_BAR_boom"][anim]);
        madnes_anim_add("mystery_symbol_boom_3", anim, icons["symbol_BAR_boom"][anim]);
    }

    madnes_add_sprite("mystery_btn_1", "mystery_btn_disabled", -9999, -9999);
    madnes_add_sprite("mystery_btn_2", "mystery_btn_disabled", -9999, -9999);
    madnes_add_sprite("mystery_btn_3", "mystery_btn_disabled", -9999, -9999);

    //madnes_add_sprite("your_mystery_win", "your_mystery_win", -9999, -9999, 1, 0.5, 0.5);

    var infotext = madnes_get_json("infotext");

    for(var i in infotext)
    {
        if(typeof infotext[i].name !== "undefined" && infotext[i].name == "bonus_win")
        {
            var style = {
                "font": "32px Arial",
                "fill": "#ffffff",
                "fontWeight": "",
                "stroke": "#606060",
                "strokeThickness": 4
            };
            madnes_add_text("your_mystery_win", -9999, -9999, infotext[i].content, style);
            madnes_set_img_center("your_mystery_win", 0.5, 0);
        }
        else if(typeof infotext[i].name !== "undefined" && infotext[i].name == "bonus_select")
        {
            var style = {
                "font": "30px Arial",
                "fill": "#ffffff",
                "fontWeight": "bold",
                "stroke": "#606060",
                "strokeThickness": 4
            };
            madnes_add_text("mystery_btn_text_1", -9999, -9999, infotext[i].content, style);
            madnes_add_text("mystery_btn_text_2", -9999, -9999, infotext[i].content, style);
            madnes_add_text("mystery_btn_text_3", -9999, -9999, infotext[i].content, style);
            madnes_set_img_center("mystery_btn_text_1", 0.5, 0.5);
            madnes_set_img_center("mystery_btn_text_2", 0.5, 0.5);
            madnes_set_img_center("mystery_btn_text_3", 0.5, 0.5);
        }
    }


    //madnes_add_bitmap_text("your_mystery_sum", "font_mystery", -9999, -9999, "0", 70);
    //madnes_set_img_center("your_mystery_sum", 0.5, 0.5);

    madnes_set_input_down("mystery_btn_1", mystery_btn_dn.bind(this, 1));
    madnes_set_input_down("mystery_btn_2", mystery_btn_dn.bind(this, 2));
    madnes_set_input_down("mystery_btn_3", mystery_btn_dn.bind(this, 3));

    madnes_set_input_up("mystery_btn_1", mystery_btn_up.bind(this, 1));
    madnes_set_input_up("mystery_btn_2", mystery_btn_up.bind(this, 2));
    madnes_set_input_up("mystery_btn_3", mystery_btn_up.bind(this, 3));

    var left_tmp = 0.38;
    var dif_tmp = 0.89;

    madnes_set_img_center("mystery_symbol_1", -1 * ( left_tmp + dif_tmp * 0 ), -0.8);
    madnes_set_img_center("mystery_symbol_2", -1 * ( left_tmp + dif_tmp * 1 ), -0.8);
    madnes_set_img_center("mystery_symbol_3", -1 * ( left_tmp + dif_tmp * 2 ), -0.8);

    madnes_set_img_center("mystery_symbol_boom_1", -1 * ( left_tmp + dif_tmp * 0 ), -0.8);
    madnes_set_img_center("mystery_symbol_boom_2", -1 * ( left_tmp + dif_tmp * 1 ), -0.8);
    madnes_set_img_center("mystery_symbol_boom_3", -1 * ( left_tmp + dif_tmp * 2 ), -0.8);

    madnes_set_img_center("mystery_result_1_text", 0.5, 0.5);
    madnes_set_img_center("mystery_result_2_text", 0.5, 0.5);
    madnes_set_img_center("mystery_result_3_text", 0.5, 0.5);

    var left_tmp = 0.58;
    var dif_tmp = 1.13;

    madnes_set_img_center("mystery_result_1", -1 * ( left_tmp + dif_tmp * 0 ), -3.65);
    madnes_set_img_center("mystery_result_2", -1 * ( left_tmp + dif_tmp * 1 ), -3.65);
    madnes_set_img_center("mystery_result_3", -1 * ( left_tmp + dif_tmp * 2 ), -3.65);

    var left_tmp = 0.88;
    var dif_tmp = 1.32;

    madnes_set_img_center("mystery_btn_1", -1 * ( left_tmp + dif_tmp * 0 ), -4.9);
    madnes_set_img_center("mystery_btn_2", -1 * ( left_tmp + dif_tmp * 1 ), -4.9);
    madnes_set_img_center("mystery_btn_3", -1 * ( left_tmp + dif_tmp * 2 ), -4.9);

    madnes_add_img("mystery_fadeout_aplha", "mystery_fadeout_aplha", -9999, -9999);

    madnes_add_img("big_win", "big_win", -9999, -9999);
    madnes_add_img("mega_win", "mega_win", -9999, -9999);
    madnes_add_img("super_mega_win", "super_mega_win", -9999, -9999);

    madnes_add_bitmap_text("big_win_text", "font_mystery", -9999, -9999, "0", 80);
    madnes_set_img_center("big_win_text", 0.5, -0.6);

    //madnes_add_bitmap_text("big_win_text2", "font_mystery", 10, 200, "0123456789", 80);

    //madnes_add_bitmap_text("xxx", "font_mystery", 10, 300, "0123456789", 80);

    madnes_add_img("logo_reels", "logo_reels", wi / 2, -2, 1, 0.5, 0);

    madnes_audio_allow_multiple("stop_sound");
    madnes_audio_allow_multiple("smack_ice_bar");
}

var settings_background_pos;
export function ib27_infomenu_init()
{
    settings_background_pos = 1;
    madnes_add_img("settings_background_1", "settings_background_1", -9999, -9999);
    madnes_add_img("settings_background_2", "settings_background_2", -9999, -9999);
    madnes_add_img("settings_background_3", "settings_background_3", -9999, -9999);
    madnes_add_img("settings_background_4", "settings_background_4", -9999, -9999);


    madnes_add_img("logo_reels_1", "logo_reels", wi / 2, -2, 1, 0.5, 0);
    madnes_add_img("logo_reels_2", "logo_reels", wi / 2, -2, 1, 0.5, 0);
    madnes_add_img("logo_reels_3", "logo_reels", wi / 2, -2, 1, 0.5, 0);
    madnes_add_img("logo_reels_4", "logo_reels", wi / 2, -2, 1, 0.5, 0);

    madnes_add_group("settings_group_1");
    madnes_add_group("settings_group_2");
    madnes_add_group("settings_group_3");
    madnes_add_group("settings_group_4");

    madnes_add_to_group("settings_group_1", "logo_reels_1");
    madnes_add_to_group("settings_group_2", "logo_reels_2");
    madnes_add_to_group("settings_group_3", "logo_reels_3");
    madnes_add_to_group("settings_group_4", "logo_reels_4");


    var start_x = 450;
    var start_y = 184;

    var wi_dif = 360;
    var he_dif = 162;


    madnes_add_bitmap_text("star", "font_wintable", start_x, start_y + he_dif * 0, "0", 80);
    madnes_add_bitmap_text("grapes", "font_wintable", start_x, start_y + he_dif * 1, "0", 80);
    madnes_add_bitmap_text("dollar", "font_wintable", start_x, start_y + he_dif * 2, "0", 80);
    madnes_add_bitmap_text("melone", "font_wintable", start_x + wi_dif, start_y + he_dif * 0, "0", 80);
    madnes_add_bitmap_text("bell", "font_wintable", start_x + wi_dif, start_y + he_dif * 1, "0", 80);
    madnes_add_bitmap_text("cherry", "font_wintable", start_x + wi_dif, start_y + he_dif * 2, "0", 80);

    madnes_set_img_center("star", 0.5, 0.5);
    madnes_set_img_center("grapes", 0.5, 0.5);
    madnes_set_img_center("dollar", 0.5, 0.5);
    madnes_set_img_center("melone", 0.5, 0.5);
    madnes_set_img_center("bell", 0.5, 0.5);
    madnes_set_img_center("cherry", 0.5, 0.5);

    madnes_add_to_group("settings_group_1", "star");
    madnes_add_to_group("settings_group_1", "grapes");
    madnes_add_to_group("settings_group_1", "dollar");
    madnes_add_to_group("settings_group_1", "melone");
    madnes_add_to_group("settings_group_1", "bell");
    madnes_add_to_group("settings_group_1", "cherry");

    start_x = wi / 2;
    start_y = 278;
    he_dif = 118;

    madnes_add_bitmap_text("myst1", "font_mystery_win", start_x, start_y + he_dif * 0, "UGA", 80);
    madnes_add_bitmap_text("myst2", "font_mystery_win", start_x, start_y + he_dif * 1, "UGA", 80);
    madnes_add_bitmap_text("myst3", "font_mystery_win", start_x, start_y + he_dif * 2, "UGA", 80);

    madnes_set_img_center("myst1", 0.5, 0.5);
    madnes_set_img_center("myst2", 0.5, 0.5);
    madnes_set_img_center("myst3", 0.5, 0.5);

    madnes_add_to_group("settings_group_2", "myst1");
    madnes_add_to_group("settings_group_2", "myst2");
    madnes_add_to_group("settings_group_2", "myst3");

    madnes_set_pos("settings_group_1", -9999, -9999);
    madnes_set_pos("settings_group_2", -9999, -9999);
    madnes_set_pos("settings_group_3", -9999, -9999);
    madnes_set_pos("settings_group_4", -9999, -9999);

    var infotext = madnes_get_json("infotext");

    for(var i in infotext)
    {
        if(typeof infotext[i].page == "undefined")
        {
            continue;
        }
        var x = infotext[i].position[0];
        var y = infotext[i].position[1];
        var page = infotext[i].page;
        var lineHeight0 = infotext[i].lineHeight;
        var lineHeight1 = infotext[i].lineHeight;
        var x_add = 0;
        var center = 0;

        if(infotext[i].center && infotext[i].center == 1)
        {
            center = 1;
        }

        var style0 = {
            "font": "32px Arial",
            "fill": "#ffffff",
            "fontWeight": "",
        };
        var style1 = {
            "font": "32px Arial",
            "fill": "#ffffff",
            "fontWeight": "",
        };

        if(infotext[i].fontSize && infotext[i].font)
        {
            style0.font = infotext[i].fontSize + "px " + infotext[i].font;
            style1.font = infotext[i].fontSize + "px " + infotext[i].font;
        }
        if(infotext[i].color)
        {
            style0.fill = infotext[i].color;
            style1.fill = infotext[i].color;
        }
        if(infotext[i].bold)
        {
            if(infotext[i].bold == 1)
            {
                style0.fontWeight = "bold";
                style1.fontWeight = "bold";
            }
            else if(infotext[i].bold == 1)
            {
                style0.fontWeight = "";
                style1.fontWeight = "";
            }
        }

        if(infotext[i].title.fontSize && infotext[i].title.font)
        {
            style0.font = infotext[i].title.fontSize + "px " + infotext[i].title.font;
        }
        if(infotext[i].title.lineHeight)
        {
            lineHeight0 = infotext[i].title.lineHeight;
        }
        if(infotext[i].title.color)
        {
            style0.fill = infotext[i].title.color;
        }
        if(infotext[i].title.bold)
        {
            if(infotext[i].title.bold == 1)
            {
                style0.fontWeight = "bold";
            }
            else if(infotext[i].title.bold == 1)
            {
                style0.fontWeight = "";
            }
        }

        if(infotext[i].body.fontSize && infotext[i].body.font)
        {
            style1.font = infotext[i].body.fontSize + "px " + infotext[i].body.font;
        }
        if(infotext[i].body.color)
        {
            style1.fill = infotext[i].body.color;
        }
        if(infotext[i].body.lineHeight)
        {
            lineHeight1 = infotext[i].body.lineHeight;
        }
        if(infotext[i].body.bold)
        {
            if(infotext[i].body.bold == 1)
            {
                style1.fontWeight = "bold";
            }
            else if(infotext[i].body.bold == 1)
            {
                style1.fontWeight = "";
            }
        }
        if(infotext[i].body.x_add)
        {
            x_add = infotext[i].body.x_add;
        }

        var line0 = 0;
        var line1 = 0;

        for(var j in infotext[i].title.content)
        {
            var text = infotext[i].title.content[j];
            madnes_add_text("info_header_" + i + "_"  + j + "_" + line0, x, y + line0 * lineHeight0, text, style0);
            if(center == 1)
            {
                madnes_set_img_center("info_header_" + i + "_"  + j + "_" + line0, 0.5, 0);
            }
            madnes_add_to_group("settings_group_" + ( page * 1 + 1 ), "info_header_" + i + "_"  + j + "_" + line0);
            line0++;
        }

        for(var j in infotext[i].body.content)
        {
            var text = infotext[i].body.content[j];
            madnes_add_text("info_body_" + i + "_"  + j + "_" + line1, x * 1 + x_add * 1, y + line0 * lineHeight0 + line1 * lineHeight1, text, style1);
            if(center == 1)
            {
                madnes_set_img_center("info_body_" + i + "_"  + j + "_" + line1, 0.5, 0);
            }
            madnes_add_to_group("settings_group_" + ( page * 1 + 1 ), "info_body_" + i + "_"  + j + "_" + line1);
            line1++;
        }

    }

    ib27_infomenu_update();
}

export var openinfo = false;

export function ib27_infomenu_open()
{
    if(openinfo) return;
    openinfo = true;

    settings_background_pos = 1;

    madnes_set_pos("settings_background_1", 0, 0);
    madnes_set_pos("settings_background_2", 2500, 0);
    madnes_set_pos("settings_background_3", 2500, 0);
    madnes_set_pos("settings_background_4", 2500, 0);

    madnes_set_pos("settings_group_1", 0, 0);
    madnes_set_pos("settings_group_2", 2500, 0);
    madnes_set_pos("settings_group_3", 2500, 0);
    madnes_set_pos("settings_group_4", 2500, 0);
}

export function ib27_infomenu_close()
{
    if(!openinfo) return;
    openinfo = false;

    madnes_set_pos("settings_background_1", -9999, -9999);
    madnes_set_pos("settings_background_2", -9999, -9999);
    madnes_set_pos("settings_background_3", -9999, -9999);
    madnes_set_pos("settings_background_4", -9999, -9999);

    madnes_set_pos("settings_group_1", -9999, -9999);
    madnes_set_pos("settings_group_2", -9999, -9999);
    madnes_set_pos("settings_group_3", -9999, -9999);
    madnes_set_pos("settings_group_4", -9999, -9999);
}

export function ib27_replay_mystery_update(win) {
    var bet_real = madnes_get_atomic_bet(bet) * 1;
    let betIndex = wallet.getBetSet().indexOf(bet_real);
    if(systemConfig.get(CONFIG_PARAMS.MODE) === MODES.REPLAY) {
        const lineWins = server_config.math_result.lineWins;
        for(let i = 0; i < lineWins.length; i++) {
            if(lineWins[i].type === "mystery" && lineWins[i].win === win) {
                const factor = lineWins[i].win /  server_config.bet
                const factorIndex = factor === 150 ? 2 : factor === 75 ? 1 : 0
                const mysteryRewards = server_config.logic.specifics.specialState.mysteryRewards;
                for(let j = 0; j < mysteryRewards.length; j++) {
                    if (mysteryRewards[j][factorIndex] === lineWins[i].win && 
                        wallet.getBetSet().indexOf(madnes_get_atomic_bet(wallet.getBet())) !== j
                    ) {
                        betIndex = j;
                    }
                }
            }
        }
    }

    madnes_set_text("myst1", madnes_money_to_coin(server_config.logic.specifics.specialState.mysteryRewards[betIndex][2]));
    madnes_set_text("myst2", madnes_money_to_coin(server_config.logic.specifics.specialState.mysteryRewards[betIndex][1]));
    madnes_set_text("myst3", madnes_money_to_coin(server_config.logic.specifics.specialState.mysteryRewards[betIndex][0]));
    return betIndex;
}

export function ib27_infomenu_update()
{
    madnes_set_text("star", server_config.logic.symbols[5].factors[2] * bet);
    madnes_set_text("grapes", server_config.logic.symbols[3].factors[2] * bet);
    madnes_set_text("dollar", server_config.logic.symbols[2].factors[2] * bet);

    madnes_set_text("melone", server_config.logic.symbols[8].factors[2] * bet);
    madnes_set_text("bell", server_config.logic.symbols[1].factors[2] * bet);
    madnes_set_text("cherry", server_config.logic.symbols[4].factors[2] * bet);

    var bet_real = madnes_get_atomic_bet(bet) * 1;
    let betIndex = wallet.getBetSet().indexOf(bet_real);

    madnes_set_text("myst1", madnes_money_to_coin(server_config.logic.specifics.specialState.mysteryRewards[betIndex][2]));
    madnes_set_text("myst2", madnes_money_to_coin(server_config.logic.specifics.specialState.mysteryRewards[betIndex][1]));
    madnes_set_text("myst3", madnes_money_to_coin(server_config.logic.specifics.specialState.mysteryRewards[betIndex][0]));
}

export function ib27_infomenu_left()
{
    if(!openinfo) return;

    if(ib27_infomenu_move_in == 0)
    {
        ib27_infomenu_move_in = 1;
        ib27_infomenu_move_dir = -1;
        ib27_infomenu_move_pos = 0;
        ib27_infomenu_move();
    }
}

export function ib27_infomenu_right()
{
    if(!openinfo) return;

    if(ib27_infomenu_move_in == 0)
    {
        ib27_infomenu_move_in = 1;
        ib27_infomenu_move_dir = 1;
        ib27_infomenu_move_pos = 0;
        ib27_infomenu_move();
    }
}

var ib27_infomenu_move_in = 0;
var ib27_infomenu_move_dir = 0;
var ib27_infomenu_move_pos = 0;
var ib27_infomenu_move_speed = 60;
var settings_background_pos2;

function ib27_infomenu_move()
{
    ib27_infomenu_move_speed = wi;

    settings_background_pos2 = settings_background_pos * 1 + ib27_infomenu_move_dir;
    if(settings_background_pos2 > 4)
    {
        settings_background_pos2 = 1;
    }
    if(settings_background_pos2 < 1)
    {
        settings_background_pos2 = 4;
    }

    ib27_infomenu_move_pos = ib27_infomenu_move_pos * 1 + ib27_infomenu_move_dir * ib27_infomenu_move_speed * -1;

    madnes_set_pos_x("settings_background_" + settings_background_pos, ib27_infomenu_move_pos, 0);
    madnes_set_pos_x("settings_background_" + settings_background_pos2, ib27_infomenu_move_pos + wi * ib27_infomenu_move_dir * 1, 0);

    madnes_set_pos_x("settings_group_" + settings_background_pos, ib27_infomenu_move_pos, 0);
    madnes_set_pos_x("settings_group_" + settings_background_pos2, ib27_infomenu_move_pos + wi * ib27_infomenu_move_dir * 1, 0);

    if(Math.abs(ib27_infomenu_move_pos) < wi)
    {
        setTimeout(ib27_infomenu_move,1000 / fps);
    }
    else
    {
        madnes_set_pos_x("settings_background_" + settings_background_pos2, 0, 0);
        madnes_set_pos_x("settings_background_" + settings_background_pos, 2500, 0);

        madnes_set_pos_x("settings_group_" + settings_background_pos2, 0, 0);
        madnes_set_pos_x("settings_group_" + settings_background_pos, 2500, 0);

        settings_background_pos = settings_background_pos2;
        ib27_infomenu_move_in = 0;
        ib27_infomenu_move_dir = 0;
        ib27_infomenu_move_pos = 0;
    }
}


// // Render pro kourovy efekt
// function ib27_render_phaser()
// {
// 	if(in_smoke_pos++%3==0 && smoke_emitter != null)
// 	{
// 		for(var i = 0; i < 5; i++)
// 		{
// 			if(freespin_state != null && freespin_state[i] != null && freespin_state[i] == 1)
// 			{
// 				if(madnes_check_focus())
// 				{
// 					var xpos = null;
// 					switch(i){
// 						case 0:
// 						case 1:
// 						case 2:
// 						case 3:
// 						case 4: xpos = [(cylinder_pos[i]+25)*wi_scale,(cylinder_pos[i]-25+ico_wi)*wi_scale]; break;
// 						default: xpos = [-9999, -9999];
// 						break;
// 					}
// 					var rep = 5;
// 					var freq = 30;
// 					smoke_emitter[i].emit('smoke', xpos, he*he_scale*0.85, { repeat: rep, frequency: freq });
// 				}
// 			}
// 		}
// 	}
// }
